// removed by extract-text-webpack-plugin
module.exports = {"container":"_13LQj","left":"_1DAAF","right":"_29sW9","avatarLink":"_1WBtw","avatar":"_25QLr","titleWrapper":"_1o9j_","titleLink":"_3mylH","title":"_1XLep","icon":"_19YSP","timeAgo":"_19YrJ","name":"_3BuB1","stats":"_2RinH","recentActivity":"_1aIzc","count":"_1TBIj","more":"_3kFU_","tooltip":"UnV9D"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-list-item-classic/post-list-item-classic.scss
// module id = 1535
// module chunks = 0